<template>
  <div
    class="sidebar"
    :style="{ height: sidebarHeight + 'px'}"
  >
    <el-menu
      class="menus"
      :default-active="index"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item
        v-if="$hasMenu('templates')"
        index="1"
        @click="$router.push({ name: 'templates', query: { type: '1', _menu:'1' }})"
      >
        <i class="iconfont">&#xe73d;</i>
        <span slot="title">{{ $t('模板库') }}</span>
      </el-menu-item>
      <el-submenu
        v-if="$hasMenu('papers')"
        index="3"
      >
        <template slot="title">
          <i class="iconfont">&#xe748;</i>
          <span slot="title">{{ $t('组卷') }}</span>
        </template>

        <el-menu-item
          v-if="$hasMenu('unitTest')"
          index="3-1"
          @click="$router.push({ name: 'unitTest', query: { _menu: '3-1' }})"
        >
          <i class="iconfont">&#xe6b2;</i>单元测试题
        </el-menu-item>
        <el-menu-item
          v-if="$hasMenu('tipAudio')"
          index="3-2"
          @click="$router.push({ name: 'tipAudio', query: { _menu: '3-2' }})"
        >
          <i class="iconfont">&#xe61c;</i>提示音管理
        </el-menu-item>
        <el-menu-item
          v-if="$hasMenu('preview')"
          index="3-3"
          @click="$router.push({ name: 'preview', query: { _menu: '3-3' }})"
        >
          <i class="el-icon-magic-stick new-icon" />课前预习题
        </el-menu-item>
        <el-menu-item
          v-if="$hasMenu('review')"
          index="3-4"
          @click="$router.push({ name: 'review', query: { _menu: '3-4' }})"
        >
          <i class="el-icon-s-flag new-icon" />课后复习题
        </el-menu-item>
        <el-menu-item
          v-if="$hasMenu('upgrade')"
          index="3-5"
          @click="$router.push({ name: 'upgrade', query: { _menu: '3-5' }})"
        >
          <i class="el-icon-s-flag new-icon" />升级测试
        </el-menu-item>
        <el-menu-item
          v-if="$hasMenu('langtest')"
          index="3-6"
          @click="$router.push({ name: 'langtest', query: { _menu: '3-6' }})"
        >
          <i class="el-icon-s-flag new-icon" />语言测评
        </el-menu-item>
      </el-submenu>

      <el-submenu
        v-if="$hasMenu('auth')"
        index="4"
      >
        <template slot="title">
          <i class="iconfont">&#xe635;</i>
          <span slot="title">{{ $t('权限') }}</span>
        </template>
        <el-menu-item
          v-if="$hasMenu('roles')"
          index="4-1"
          @click="$router.push({ name: 'roles', query: { _menu: '4-1' }})"
        >
          <i class="iconfont">&#xe7ad;</i>角色管理
        </el-menu-item>
        <el-menu-item
          v-if="$hasMenu('userRoles')"
          index="4-2"
          @click="$router.push({ name: 'userRoles', query: { _menu: '4-2' }})"
        >
          <i class="iconfont">&#xe61c;</i>分配角色
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<style lang="less" scoped>
.sidebar {
  .menus {
    height: 100%;
  }
  .iconfont .new-icon{
    margin-right: 5px;
  }
  .new-icon{
    margin-right: 0;
  }

}
</style>

<script>
const debug = require('debug')('ccs:component:sidebar');

export default {
	data() {
		return {
			index: '1'
		};
	},
	computed: {
		windowWidth: () => window.innerWidth,
		windowHeight: () => window.innerHeight,
		sidebarHeight: function() {
			// 减去顶部
			return this.windowHeight - 60;
		}
	},
	created() {
		debug('[init]');
	},
	mounted() {
		// 此处type用来设定跳转的路由链接_menu
		this.index = this.$route.query._menu;
		// console.log(this.index);
	}
};
</script>
